// extracted by mini-css-extract-plugin
module.exports = {"canvas":"scan_canvas__2CRxZ","overlay":"scan_overlay__iazEL"};